import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { handleInitialData } from '../actions/shared'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'

import Snackbar from './Snackbar'

import Questions from './Questions'
import QuestionsFlex from './QuestionsFlex'
import Attachments from './Attachments'
import CommercialTerms from './CommercialTerms/CommercialTerms'
import Spaces from './CommercialTerms/Spaces'

import t from '../utils/lang'

import { hideSnackbar } from '../actions/snackbar'

function TabContainer(props) {
  return (
    <Typography component="div" className='tab-container'>
      {props.children}
    </Typography>
  )
}

class Dashboard extends Component {
  state = {
    tab: 0,
    lang: 'en'
  }

  componentDidMount(prevProps, prevState) {
    if (prevProps !== this.props) {
      const { hashId } = this.props.match.params
      this.props.onHanleInitialData(hashId)
    }
  }

  componentDidUpdate(prevProps) {
    const { lang } = this.props

    if (lang !== prevProps.lang) {
      this.setState({ lang })
    }
  }

  handleChange = (event, value) => {
    this.setState({ tab: value });
  }

  

  render() {
    const { tab, lang } = this.state
    const { isFlex, snackbar, hideSnackbar } = this.props
    const { snackbarOpen, snackbarMessage, snackbarAction, snackbarDuration, snackbarSeverity } = snackbar;

    return (
      <Fragment>
        <div className='questions-container'>
          <Tabs value={tab} onChange={this.handleChange}>
            <Tab value={0} label={t[lang].questionsTab} />
            {!isFlex && <Tab value={1} label={t[lang].spacesTab} />}
            {!isFlex && <Tab value={2} label={t[lang].commercialTermsTab} />}
            <Tab value={3} label={t[lang].attachmentsTab} />
          </Tabs>

          {tab === 0 && <TabContainer>
            {isFlex
              ? <QuestionsFlex />
              : <Questions />}
          </TabContainer>}

          {tab === 1 && !isFlex && <TabContainer>
            <Spaces />
          </TabContainer>}

          {tab === 2 && !isFlex && <TabContainer>
            <CommercialTerms />
          </TabContainer>}

          {tab === 3 && <TabContainer>
            <Typography variant="subheading">
              <Attachments />
            </Typography>
          </TabContainer>}
        </div>
        <Snackbar
          open={snackbarOpen}
          onClose={hideSnackbar}
          severity={snackbarSeverity}
          action={snackbarAction}
          autoHideDuration={snackbarDuration}
        >
          {snackbarMessage}
        </Snackbar>
      </Fragment>
    )
  }
}

function mapStateToProps({ rfpData, snackbar, loadingBar }) {
  const { lang, isFlex } = rfpData

  return {
    lang,
    isFlex,
    snackbar
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideSnackbar: () => dispatch(hideSnackbar()),
    onHanleInitialData: hashId => dispatch(handleInitialData(hashId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)


// WEBPACK FOOTER //
// ./src/components/Dashboard.js